module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/title_bg-b41f8461e1223721f895eb59516e51d2.png";